module.exports = new __parcel__URL__("Palikkatakomo.32b029dc.jpeg").toString();